import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import TeamIntegrationItem from './TeamIntegrationItem';
import { getIconComponent } from 'utils/icons/iconUtils';
import { PowerOutlinedIcon } from 'icons/materialIcons';

const TeamMemberImportContainer = ({
    searchTerm = '',
    subteamId = null,
    availableIntegrations = [],
    onIntegrationClick,
    isIntegrationConnected,
    getConnectionStatus
}) => {
    // Team Member Import integrations: Active Directory, Eventbrite
    const integrationNames = ['Active Directory', 'Eventbrite'];

    const memberImportIntegrations = integrationNames
        .map(name => {
            const backendIntegration = availableIntegrations.find(
                i => i.name?.toLowerCase() === name.toLowerCase() ||
                    i.displayName?.toLowerCase() === name.toLowerCase()
            );

            if (backendIntegration) {
                return {
                    name: backendIntegration.displayName || backendIntegration.name,
                    _id: backendIntegration._id,
                    isConnected: isIntegrationConnected ? isIntegrationConnected(name) : false,
                    connectionStatus: getConnectionStatus ? getConnectionStatus(name) : 'disconnected'
                };
            }

            return {
                name: name,
                _id: null,
                isConnected: false,
                connectionStatus: 'disconnected'
            };
        })
        .filter(integration =>
            integration.name.toLowerCase().includes(searchTerm.toLowerCase())
        );

    // Only show the "Don't see your integration" option when not searching or when the search matches it
    const showRequestOption = !searchTerm || 'don\'t see your integration'.includes(searchTerm.toLowerCase());

    if (memberImportIntegrations.length === 0 && !showRequestOption && searchTerm) {
        return null;
    }

    return (
        <Box>
            <Typography
                variant="h5"
                sx={{
                    fontWeight: 600,
                    mb: 3,
                    color: '#242020',
                    fontSize: '2rem'
                }}
            >
                Team Member Import
            </Typography>
            <Typography
                variant="body1"
                sx={{
                    mb: 3,
                    color: '#828282'
                }}
            >
                Create and update Touch team members by syncing with your HR directory
            </Typography>
            <Grid container spacing={2}>
                {memberImportIntegrations.map((integration) => (
                    <Grid item xs={12} sm={6} md={3} key={integration.name}>
                        <TeamIntegrationItem
                            text={integration.name}
                            icon={getIconComponent(integration.name)}
                            onClick={() => onIntegrationClick && onIntegrationClick(integration.name)}
                            isConnected={integration.isConnected}
                            connectionStatus={integration.connectionStatus}
                        />
                    </Grid>
                ))}

                {/* Request integration option */}
                {showRequestOption && (
                    <Grid item xs={12} sm={6} md={3}>
                        <TeamIntegrationItem
                            text={
                                <Box>
                                    <Typography sx={{ fontSize: '12px', fontWeight: 600 }}>
                                        Don't see your integration?
                                    </Typography>
                                    <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#818181' }}>
                                        Request one here
                                    </Typography>
                                </Box>
                            }
                            icon={<PowerOutlinedIcon sx={{ color: '#29AEF8' }} />}
                        />
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default TeamMemberImportContainer;

